import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackAgentChatRunSettled.meta';

export type AgentChatRunOutcome = 'finished' | 'errored' | 'aborted' | 'abandoned';

export type UseTrackAgentChatRunSettledParams = {
  canvas_id: string;
  thread_id: string;
  run_id?: string;
  action?: string;
  duration_ms: number;
  run_finished_received: boolean;
  result_arrived: boolean;
  outcome: AgentChatRunOutcome;
  tab_hidden: boolean;
  variant_count_requested?: number;
  variant_count_delivered?: number;
  variant_count_source?: 'composer_pill' | 'toolbar_pill';
};

export const useTrackAgentChatRunSettled = () => {
  const { track } = useAnalyticsUtilities();

  const trackAgentChatRunSettled = useCallback(
    (params: UseTrackAgentChatRunSettledParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackAgentChatRunSettled };
};
